import { render, staticRenderFns } from "./Qi.vue?vue&type=template&id=003bbcdd&scoped=true&"
import script from "./Qi.vue?vue&type=script&lang=js&"
export * from "./Qi.vue?vue&type=script&lang=js&"
import style0 from "./Qi.vue?vue&type=style&index=0&id=003bbcdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003bbcdd",
  null
  
)

export default component.exports